import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css'; 
import logo from '../assets/logo.png';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  // URL OFICIAL DE PRODUÇÃO (Coolify)
  const API_URL = "https://api-draft.hevile.com.br";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // --- CORREÇÃO CRÍTICA DO LOOP ---
        // 1. Salvamos como 'token' (o nome que o App.jsx e DraftPage.jsx procuram)
        localStorage.setItem('token', data.access_token);
        
        // 2. Removemos o 'accessToken' antigo para garantir que o navegador não se confunda
        localStorage.removeItem('accessToken');
        
        // 3. Redireciona para o Draft
        navigate('/'); 
      } else {
        setError(data.msg || 'Usuário ou senha incorretos.');
      }
    } catch (err) {
      console.error(err);
      setError('Erro de conexão com o servidor. Verifique a internet.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={logo} alt="Logo Hevile" className="login-logo" />
        <h2>Acesso ao Sistema</h2>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Usuário</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Digite seu usuário"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite sua senha"
              required
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="login-btn" disabled={isLoading}>
            {isLoading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;